import "./Badge.scss";

interface BadgeProps {
  height?: string;
  text: string;
}

const Badge = ({ height, text }: BadgeProps) => (
  <div className="badgeContainer" style={{ height }}>
    <div className="badgeText">{text}</div>
  </div>
);

export default Badge;
